export const EmptyImgImg = '/assets/img/empty-img.png'

export const FiltersDataKey = 'filters'
export const SelectedTicketsDataKey = 'selectedTickets'
export const LoadedTablesDataKey = 'loadedTables'
export const NewCustomerDataKey = 'newCustomer'
